jQuery(function ($) {
	$('[data-toggle="tooltip"]').tooltip();
});
